import React, { forwardRef } from "react";
import { useLanguage } from "../../localization/LanguageContext";
import "./Button.css";

const joinClasses = (...values) => values.filter(Boolean).join(" ");

export const Button = forwardRef(function Button({
  children,
  variant = "primary",
  size = "medium",
  loading = false,
  leadingIcon,
  trailingIcon,
  fullWidth = false,
  className = "",
  disabled,
  type = "button",
  ...rest
}, ref) {
  const { copy } = useLanguage();
  // Buttons often receive a short product literal directly. Translate those
  // at the shared control boundary, while leaving React content and business
  // values (such as ticket references) untouched.
  const label = typeof children === "string" ? copy(children) : children;
  return (
    <button
      ref={ref}
      type={type}
      className={joinClasses("crm-button", className)}
      data-variant={variant}
      data-size={size}
      data-full-width={fullWidth ? "true" : undefined}
      data-loading={loading ? "true" : undefined}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <span className="crm-button__spinner" aria-hidden="true" />
      ) : (
        leadingIcon && <span className="crm-button__icon">{leadingIcon}</span>
      )}
      <span className="crm-button__label">{label}</span>
      {!loading && trailingIcon && (
        <span className="crm-button__icon">{trailingIcon}</span>
      )}
    </button>
  );
});
